/**
 * ov1uir
 * previously components/offers/index.th.tsx
 * no functional changes
 * TODO: determine how much of this can be moved to new v2 UI
 */
import React from 'react';

import { IBaseProps, OnClick } from '@rbi-ctg/frontend';
import { IOffer } from '@rbi-ctg/menu';
import { useOffer } from 'components/offer/use-offer';
import { IOfferFeedbackEntryFragment } from 'generated/rbi-graphql';

import OfferLayout from './offer-layout';

interface IOfferProps extends IBaseProps {
  offer: IOffer;
  offerFeedback: IOfferFeedbackEntryFragment | null;
  onClick: OnClick;
  isGridLayout?: boolean;
}

const Offer: React.FC<IOfferProps> = ({
  className = '',
  offer,
  offerFeedback,
  onClick,
  isGridLayout,
}) => {
  const { id, isNewOffer, endingIn, platforms, displayLoginRequiredBadge, state } = useOffer({
    offer,
    offerFeedback,
  });

  return (
    <OfferLayout
      id={id}
      isNewOffer={isNewOffer}
      className={className}
      offer={offer}
      onClick={onClick}
      endingIn={endingIn}
      platforms={platforms}
      displayLoginRequiredBadge={displayLoginRequiredBadge}
      state={state}
      isGridLayout={isGridLayout}
    />
  );
};

export default Offer;
